// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"d9424e16","472":"df900a32","711":"b98f5e34","853":"40af25ce","988":"b778da51"}[chunkId] + ".chunk.js";
};